var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedIninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.995 22l.005-.001v-7.335c0-3.588-.772-6.352-4.967-6.352-2.017 0-3.37 1.106-3.923 2.155h-.058V8.5H9.074v13.499h4.142v-6.612c0-1.74.33-3.424 2.486-3.424 2.124 0 2.156 1.987 2.156 3.536v6.5h4.137zM2 8.5h4.5V22H2V8.5zM4.25 2A2.245 2.245 0 002 4.24 2.263 2.263 0 004.25 6.5 2.263 2.263 0 006.5 4.24 2.246 2.246 0 004.25 2z",
    fill: "#fff"
  })));
}

export default SvgLinkedIninline;